//multi-column.liquid animated icons
const animationContainers = document.querySelectorAll('.lottieAnimation--container');
if (animationContainers) {
animationContainers.forEach(function(container) {
    const animationUrl = container.dataset.lottieUrl;

    const animation = bodymovin.loadAnimation({
        container: container, 
        path: animationUrl, 
        renderer: 'svg',
        loop: true,
        autoplay: true,
        name: "Demo Animation", 
    });
});
}

//<two-slide-carousel></two-slide-carousel>
class TwoSlideCarousel extends HTMLElement {
    constructor() {
        super();
        this.currentIndex = 0;
    }
  
    connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.slide'));
        this.totalSlides = this.slides.length;
        this.prevButton = this.querySelector('.carousel-prev-button');
        this.nextButton = this.querySelector('.carousel-next-button');
        this.updateVisibleSlides();
  
        this.prevButton.addEventListener('click', () => this.moveCarousel(-1));
        this.nextButton.addEventListener('click', () => this.moveCarousel(1));
    }
  
    moveCarousel(direction) {
        const slidesToMove = window.innerWidth <= 1000 ? 1 : 2;
        this.currentIndex += direction * slidesToMove;
        this.currentIndex = Math.max(0, Math.min(this.currentIndex, this.totalSlides - slidesToMove));
        this.updateVisibleSlides();
    }
  
    updateVisibleSlides() {
        const slidesToShow = window.innerWidth <= 1000 ? 1 : 2;
        this.slides.forEach((slide, index) => {
            slide.style.display = (index >= this.currentIndex && index < this.currentIndex + slidesToShow) ? 'block' : 'none';
        });


        this.prevButton.style.display = this.currentIndex > 0 ? 'block' : 'none';
        this.nextButton.style.display = (this.currentIndex + slidesToShow) < this.totalSlides ? 'block' : 'none';
    }
}

if (!window.customElements.get('two-slide-carousel')) {
    window.customElements.define('two-slide-carousel', TwoSlideCarousel);
}


/* video.liquid && services.liquid */
document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.container-block--video .carousel');
    carousels.forEach(carousel => {
        $(carousel).slick({
            dots: false,
            infinite: false,
            nextArrow: carousel.closest('.container-block--video').querySelector('.slick-next-custom'),
            prevArrow: carousel.closest('.container-block--video').querySelector('.slick-prev-custom'),
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1001,
                    settings: 'unslick'
                }
            ]
        });
    });
});



/* faq.liquid */
document.addEventListener('DOMContentLoaded', function() {
    const categoryLinks = document.querySelectorAll('.faq__toc-item');

    if (categoryLinks && window.innerWidth <= 1000){
      categoryLinks.forEach(link => {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          const targetId = this.getAttribute('href');
          const targetElement = document.querySelector(targetId);

          if (targetElement ) {
            const offset = 150; 
            const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        });
      });
    }
});
